'use client';

import { useEffect, useRef, useCallback, useState } from 'react';
import { usePathname } from 'next/navigation';

export default function CustomCursor() {
  const cursorRef = useRef<HTMLDivElement>(null);
  const pathname = usePathname();
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  // Detect touch device
  useEffect(() => {
    const isTouch = window.matchMedia('(pointer: coarse)').matches || 'ontouchstart' in window;
    setIsTouchDevice(isTouch);
  }, []);

  const onLinkEnter = useCallback(() => {
    cursorRef.current?.classList.add('active');
  }, []);

  const onLinkLeave = useCallback(() => {
    cursorRef.current?.classList.remove('active');
  }, []);

  // Mouse move effect - runs once
  useEffect(() => {
    if (isTouchDevice) return;

    const cursor = cursorRef.current;
    if (!cursor) return;

    const onMouseMove = (e: MouseEvent) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    };

    document.addEventListener('mousemove', onMouseMove);
    return () => document.removeEventListener('mousemove', onMouseMove);
  }, [isTouchDevice]);

  // Link hover effect - runs on route change
  useEffect(() => {
    if (isTouchDevice) return;

    let links: NodeListOf<Element> | null = null;

    // Small delay to ensure DOM is ready after navigation
    const timeout = setTimeout(() => {
      links = document.querySelectorAll('.link');

      links.forEach(link => {
        link.addEventListener('mouseenter', onLinkEnter);
        link.addEventListener('mouseleave', onLinkLeave);
      });
    }, 100);

    return () => {
      clearTimeout(timeout);
      if (links) {
        links.forEach(link => {
          link.removeEventListener('mouseenter', onLinkEnter);
          link.removeEventListener('mouseleave', onLinkLeave);
        });
      }
    };
  }, [pathname, onLinkEnter, onLinkLeave, isTouchDevice]);

  if (isTouchDevice) return null;

  return (
    <div className="cursor" ref={cursorRef}>
      Zobrazit<br />projekt
    </div>
  );
}
